import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tests',
  templateUrl: './tests.component.html',
  styles: [
  ]
})
export class TestsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
